import { render, staticRenderFns } from "./TeamContacts.vue?vue&type=template&id=1d8edd4e"
import script from "./TeamContacts.vue?vue&type=script&lang=js"
export * from "./TeamContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports